<template>
  <div class="data-table-list-status" style="padding: 0px 10px;">
    {{ list.status == 0 ? "-" : list.status }}
    <el-dropdown trigger="click" @visible-change="dropdown = list.list_id">
      <div
        class="data-table-list-status-button pointer"
        :class="
          list.list_status === ''
            ? 'info'
            : list.list_status === null
            ? 'info'
            : list.list_status === '未設定'
            ? 'info'
            : list.list_status == '進行中'
            ? 'primary'
            : list.list_status == '依頼中'
            ? 'success'
            : list.list_status == '終了'
            ? 'warning'
            : list.list_status == 'アーカイブ'
            ? 'archive'
            : ''
        "
        style="margin-left:10px; width:100px"
      >
        <div class="status-button">
          <i class="el-icon-minus" v-show="list.list_status == ''"></i>
          <i class="el-icon-minus" v-show="list.list_status == null"></i>
          <i class="el-icon-minus" v-show="list.list_status == '未設定'"></i>
          <span v-show="list.list_status == '依頼中'">!</span>
          <i class="el-icon-right" v-show="list.list_status == '進行中'"></i>
          <i class="el-icon-check" v-show="list.list_status == '終了'"></i>
        </div>
        {{ list.list_status == null || list.list_status == "" ? "未設定" : list.list_status }}
        <font-awesome-icon icon="caret-down" style="margin-left:5px; color:#aaa" />
      </div>
      <el-dropdown-menu slot="dropdown">
        <div v-if="dropdown==list.list_id">
        <el-dropdown-item icon="el-icon-minus" @click.native="changeListStatus('未設定', list.list_id, index)">未設定</el-dropdown-item>
        <el-dropdown-item icon="el-icon-right" @click.native="changeListStatus('進行中', list.list_id, index)">進行中</el-dropdown-item>
        <el-dropdown-item icon="el-icon-warning-outline" @click.native="changeListStatus('依頼中', list.list_id, index)">依頼中</el-dropdown-item>
        <el-dropdown-item icon="el-icon-check" @click.native="changeListStatus('終了', list.list_id, index)">終了</el-dropdown-item>
        <el-dropdown-item icon="el-icon-takeaway-box" v-show="activate != 12" @click.native="changeListStatus('アーカイブ', list.list_id, index)"
          >アーカイブ</el-dropdown-item
        >
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "memberDropdown",
  props: ["list", "index"],
  data() {
    return {
      dropdown: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  methods: {
    changeListStatus(name, status, id, target_client_id, index) {
      this.$emit("changeListStatus", name, status, id, target_client_id, index);
    },
  },
  filters: {
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
};
</script>

<style></style>
